module.exports = __webpack_public_path__ + "img/DE02806.1f071888.png";